<script setup lang="ts">
import Button from '../Button/Button.vue'
import { IconName } from '../Icon/types'

interface Props {
  iconName: IconName
  ariaLabel: string
  showButton: boolean
  onClick: () => void
}

defineProps<Props>()
</script>

<template>
  <div class="flex w-4 justify-center">
    <Button
      v-show="showButton"
      :icon="iconName"
      :aria-label
      @click="onClick"
    ></Button>
  </div>
</template>
